import React from "react";
import "./LatestArticle.css";
// import bgImg from "../../../Assets/Images/Image [__wab_img] 1.webp";
// import bgImg2 from "../../../Assets/Images/Image [__wab_img].webp";
import arrowIcon from "../../../Assets/Images/arrow_Right_20dp_FILL_wght300.png";
import blueIcon from "../../../Assets/Images/blueArrow.png";
import "../OurTechAndFram/OurTechAndFrame.css";
import { Link } from "react-router-dom";

const LatestArticle = () => {
  return (
    <section id="blogs" className="latest-articles-section">
      <div>
        <img className="imgOne" src="https://res.cloudinary.com/davmkct9m/image/upload/v1769585754/Image___wab_img_1_xmgwnh.png" alt="" />
        <img className="imgTwo" src="https://res.cloudinary.com/davmkct9m/image/upload/v1769585623/Image___wab_img_zlrkb3.png" alt="" />
      </div>

      <div className="latest-articles-inner">
        <div className="latest-heading">
          <h2 className="fw-semibold">The Things We Learn Mid Project</h2>
          <p className="text-black latest-article-description">
            In this section we write about decisions taken under duress,
            tradeoffs that mattered and lessons learned that only show up once a
            product is live. If you are building software, these stories will
            feel familiar.
          </p>
        </div>

        <div className="latest-cards-container">
          <div className="latest-card-wrapper left">
            <article className="latest-card latest-card-pad  left">
              <span className="tag px-4 py-3">Software Development</span>
              <h5 className="fw-semibold mt-4 latest-sub-head">
                The Importance of Proper Requirements Analysis in Software
                Projects
              </h5>
              <p className="small latest-article-text">
                Over the past few years, I’ve had the opportunity to work with
                various companies and clients from around the world. It's been a
                great experience, but also an eye-opener.A common pattern I’ve
                seen is that many clients 
              </p>
              <Link to="/blog1">
                {" "}
                <button className="read-more-btn  btnOne ">
                  Read More{" "}
                  <span className="icon">
                    <img src={arrowIcon} alt="" />
                  </span>
                </button>
              </Link>
            </article>
          </div>

          <div className="latest-card-wrapper  center">
            <article className="latest-card latest-card-pad center">
              <span className="tag px-4 py-3">Software Development</span>
              <h5 className="fw-semibold my-4 latest-sub-head">
                Some Thing's I've Learned While Working with .NET
              </h5>
              <p className="small  latest-article-text">
                One of the most rewarding (and challenging) projects I’ve worked
                on recently is 𝐆𝐨𝟓𝟎𝟓𝟎 a UK-based subscription-sharing platform.
                The idea was simple, but the execution? Not so much. From the
                start, the platform needed to handle user authentication,
                subscriptions, payments, real-time interactions, and a clean UI.
              </p>
              <Link to="/blog2">
                <button className="read-more-btn btnTwo  ">
                  Read More{" "}
                  <span className="icon">
                    <img src={blueIcon} alt="" />
                  </span>
                </button>
              </Link>
            </article>
          </div>

          <div className="latest-card-wrapper  right">
            <article className="latest-card latest-card-pad right">
              <span className="tag px-4 py-3">Engineering Impact</span>
              <h5 className="fw-semibold latest-sub-head my-4">
                Small Engineering Decisions That Create Big Wins
              </h5>
              <p className="small latest-article-text">
                Most performance gains come from small, smart improvements. We
                focus on the details that others overlook. Faster load times,
                smoother user flows, cleaner architectures. Over time, these
                choices add up to software that feels solid, reliable, and easy
                to grow.
              </p>
              <Link to="/blog3">
                <button className="read-more-btn btnOne">
                  Read More{" "}
                  <span className="icon">
                    <img src={arrowIcon} alt="" />
                  </span>
                </button>
              </Link>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestArticle;
